import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import Table from '../Listing/Table';
import axios from 'axios';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL } from '../../api';

const columns = [
    {
        Header: 'Nom',
        accessor: 'firstName',
        Cell: (row) => (
            <span style={{ fontSize: 13, fontWeight: 500, color: '#111827' }}>
                {row.firstName} {row.lastName}
            </span>
        ),
    },
    {
        Header: 'Email',
        accessor: 'email',
        Cell: (row) => <span style={{ fontSize: 12, color: '#6c757d' }}>{row.email}</span>,
    },
];

export default function RoleUsersModal({ show, onClose, role }) {
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!show || !role) return;
        setIsLoading(true);
        axios.get(`${API_BASE_URL}/api/v1/admin/roles/${role.id}/users`, { withCredentials: true })
            .then(({ data }) => setUsers(data))
            .catch(() => setUsers([]))
            .finally(() => setIsLoading(false));
    }, [show, role]);

    return (
        <Modal
            id="roleUsersModal"
            title={role ? `Utilisateurs - ${role.name}` : 'Utilisateurs'}
            show={show}
            onClose={onClose}
            icon={faUsers}
            iconBg="#e0e7ff"
            iconColor="#4338ca"
            classSize="modal-lg"
        >
            <Table
                columns={columns}
                data={users}
                loading={isLoading}
                totalElements={users.length}
            />
        </Modal>
    );
}
